import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { AspectRatio } from "../../_shared-components/image-related/AspectRatio";
import { FocalImageWithPlayButton } from "./FocalImageWithPlayButton";
import { SwarovskiLink } from "../../_shared-components/ui-elements/SwarovskiLink";

import {
  StyledStoryEmoHeadline,
  StyledStorySeoHeadline,
  StyledStoryTagsList,
  StyledStoryTime,
} from "../elements/styled-elements";
import React from "react";
import { VideoTeaserType } from "@swo/storefront";
import { pipe } from "fp-ts/lib/function";
import { nonEmptyArray, option } from "fp-ts";
import { ExpandedStoryTeaser } from "../../../layouts/stories/stories-overview-page/stories-overview-page-layout";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../../domain/swarovski-optik/products/product-name/product-name-renderer";
import { useNavigate } from "react-router";
import { css } from "@emotion/react";
import { T } from "../../T";

export const VideoStoryElement: ReactTFC<
  Omit<VideoTeaserType, "tags"> & { tags: ExpandedStoryTeaser["tags"] }
> = props => {
  const navigate = useNavigate();

  const linkToStoryWithVideoHook = {
    pathname: props.link,
    hash: "#v",
  };

  function onClick() {
    void navigate(linkToStoryWithVideoHook);
  }

  return (
    <div>
      <div
        css={css`
          aspect-ratio: 16 / 9;
          position: relative;
        `}
      >
        <FocalImageWithPlayButton
          image={props.imageWithFocalPoint}
          onClick={onClick}
          imageSizes="(max-width: 767px) 100vw, (max-width: 1399px) 50vw, 700px"
        />
      </div>

      <SwarovskiLink link={linkToStoryWithVideoHook} isInternal={true} styled={"no-decoration"} scrollToTop={true}>
        <StyledStorySeoHeadline>
          <EXPERIMENTAL_TextWithProductNameRenderer text={props.seoHeadline} />
        </StyledStorySeoHeadline>
        <StyledStoryEmoHeadline>
          <EXPERIMENTAL_TextWithProductNameRenderer text={props.emoHeadline} />
        </StyledStoryEmoHeadline>
      </SwarovskiLink>

      {false &&
        pipe(
          props.tags,
          nonEmptyArray.fromArray,
          option.map(tags => <StyledStoryTagsList tags={tags} />),
          option.getOrElseW(() => null),
        )}

      {props.videoLengthLabel && (
        <StyledStoryTime>
          <T>{props.videoLengthLabel}</T>
        </StyledStoryTime>
      )}
    </div>
  );
};
